import IconFavorite from '../../assets/icons/icon-favorite.svg'
import IconFavoriteFull from '../../assets/icons/icon-favorite-full.svg'
import IconLoading from '../../assets/loading-gif.gif'
import React from 'react'
import { Suspense, useEffect, useState } from 'react'
import { Enterprise2 } from '../../interfaces/enterprise/enterprise_2'
import SkeletonLoading from '../common/SkeletonLoading'
import { RELOAD_PAGE } from '../../constants/storageNames'
import userApi from '../../store/reducers/users/userApi'
import { useAuth } from '../../hooks/useAuth'
import { IFavoriteEnterpriseToken } from '../../interfaces/users/favoriteEnterpriseToken'
import { isValidStr } from '../../common_functions'
import { USER_CLAIM_FAVORITES_ENTERPRISES } from '../../constants/userClaims'
import { IFavoriteEnterpriseClaim } from '../../interfaces/users/favoriteEnterpriseClaim'
import { USERINFOS, USER_FAVORITES_ENTERPRISES } from '../../constants/loginInfos'
import { ModalError } from '../Modais/ModalError'

interface Props {
  enterpriseId: string
  enterpriseTitle?: string
  isFavoriteDefault?: boolean | undefined
  removeFavorite?: (elementObj: IFavoriteEnterpriseClaim) => void | undefined
}
export default function FavoriteEnterpriseCircle({
  enterpriseId,
  enterpriseTitle,
  isFavoriteDefault = undefined,
  removeFavorite
}: Props) {
  //CODIGO DOS FAVORITOS
  const auth = useAuth()
  const reloadPageLocal = parseInt(sessionStorage.getItem(RELOAD_PAGE) ?? '0')
  const [errorFavoriteLocal, seterrorFavoriteLocal] = useState(false)
  const userInfos = Array.isArray(auth.loginUser) ? auth.loginUser[0] : auth.loginUser
  const [showModalError, setShowModalError] = useState(false)
  const [favoriteEnterprises, setfavoriteEnterprises] = useState<IFavoriteEnterpriseClaim[]>(
    userInfos ? JSON.parse(localStorage.getItem(USER_FAVORITES_ENTERPRISES) ?? '[]') : []
  )

  const handleCloseModal = () => {
    setShowModalError(false)
  }

  // useEffect(() => {
  //   if (auth.authenticated && !isValidStr(auth.loginUser[0].AccessToken) && reloadPageLocal <= 3) {
  //     window.location.reload()
  //     let counterReload = parseInt(sessionStorage.getItem(RELOAD_PAGE) ?? '0')
  //     counterReload += 1
  //     sessionStorage.setItem(RELOAD_PAGE, counterReload.toString())
  //   } else if (reloadPageLocal > 3) {
  //     seterrorFavoriteLocal(true)
  //   }
  // }, [])

  const [isFavoriteEnterprise, setIsFavoriteEnterprise] = useState(
    isFavoriteDefault != undefined ? isFavoriteDefault : false
  )

  useEffect(() => {
    if (typeof favoriteEnterprises === 'string') {
      setfavoriteEnterprises(JSON.parse(favoriteEnterprises))
    }
  }, [favoriteEnterprises])

  useEffect(() => {}, [isFavoriteDefault])

  useEffect(() => {
    setfavoriteEnterprises(getFavoritesEnterprises())
  }, [window.location])

  const [
    useFavoriteEnterprise,
    { isSuccess: isSuccessFavorite, isError: isErrorFavorite, isLoading: isLoadingFavorite }
  ] = userApi.useAddFavoriteEnterpriseMutation()
  const [
    useFavoriteDeleteEnterprise,
    {
      isSuccess: isSuccessFavoriteDelete,
      isError: isErrorFavoriteDelete,
      error: errorFavoriteDelete,
      isLoading: isLoadingFavoriteDelete
    }
  ] = userApi.useDeleteFavoriteEnterpriseMutation()

  useEffect(() => {
    if (isErrorFavoriteDelete) handleSuccessFavoriteDelete(true)
  }, [isErrorFavoriteDelete])

  const getFavoritesEnterprises = () => {
    var favoritesAux: IFavoriteEnterpriseClaim[] =
      auth.loginUser[0] != null && auth.loginUser[0].User != null
        ? JSON.parse(localStorage.getItem(USER_FAVORITES_ENTERPRISES) ?? '[]')
        : []
    return favoritesAux
  }

  const handlefavoriteEnterprise = async (fav: boolean) => {
    if (!errorFavoriteLocal) {
      const newEnterprise: IFavoriteEnterpriseClaim = {
        EnterpriseId: enterpriseId,
        EnterpriseName: null
      }

      if (removeFavorite != undefined) {
        removeFavorite(newEnterprise)
      } else {
        if (auth.authenticated) {
          let userId = userInfos.User.Id
          let token = userInfos.AccessToken
          let content: IFavoriteEnterpriseToken = {
            userId: userId,
            enterpriseId: enterpriseId,
            token: token
          }
          if (fav) {
            await useFavoriteDeleteEnterprise(content)
          } else {
            await useFavoriteEnterprise(content)
          }
        } else {
          window.location.href = '/entrar'
        }
      }
    } else {
      setShowModalError(true)
      setTimeout(() => {
        setShowModalError(false)
      }, 2000)
    }
  }

  useEffect(() => {
    setIsFavoriteEnterprise(isFavoriteDefault != undefined ? isFavoriteDefault : isFavorite())
  }, [location.pathname])

  useEffect(() => {
    if (isSuccessFavorite) {
      handleSuccessFavorite(false)
    }
  }, [isSuccessFavorite])

  useEffect(() => {
    if (isErrorFavoriteDelete) {
      handleSuccessFavorite(true)
    }
  }, [isErrorFavorite])

  useEffect(() => {
    if (isSuccessFavoriteDelete) {
      handleSuccessFavoriteDelete(false)
    }
  }, [isSuccessFavoriteDelete])

  const handleSuccessFavoriteDelete = (isError: boolean) => {
    setIsFavoriteEnterprise(false)
    updateListFavorites(true)
    if (isError) {
      let messageError = 'Favorito do Usuário não encontrada'
      if (window.location.pathname == '/favoritos' && errorFavoriteDelete) {
        if (JSON.stringify(errorFavoriteDelete).includes(messageError)) {
          localStorage.setItem(
            USER_FAVORITES_ENTERPRISES,
            JSON.stringify(favoriteEnterprises.filter((x) => x.EnterpriseId != enterpriseId))
          )
        }
      }
    }
    // if(window.location.pathname == '/favoritos'){
    //   setTimeout(() => {
    //     window.location.reload()
    //   }, 500);
    // }
  }

  const handleSuccessFavorite = (isError: boolean) => {
    sessionStorage.removeItem(RELOAD_PAGE)
    setIsFavoriteEnterprise(true)
    updateListFavorites(false)
    if (isError) {
      if (window.location.pathname == '/favoritos') {
        setTimeout(() => {
          window.location.reload()
        }, 500)
      }
    }
  }

  const updateListFavorites = (isDelete: boolean) => {
    const newEnterprise: IFavoriteEnterpriseClaim = {
      EnterpriseId: enterpriseId,
      EnterpriseName: null
    }
    let favoriteEnterprisesAux: IFavoriteEnterpriseClaim[] = userInfos
      ? JSON.parse(localStorage.getItem(USER_FAVORITES_ENTERPRISES) ?? '[]')
      : []
    if (isDelete) {
      favoriteEnterprisesAux = favoriteEnterprisesAux.filter(
        (x: IFavoriteEnterpriseClaim) => x.EnterpriseId != enterpriseId
      )
      setIsFavoriteEnterprise(false)
    } else {
      favoriteEnterprisesAux.push(newEnterprise)
      setIsFavoriteEnterprise(true)
    }

    setfavoriteEnterprises(favoriteEnterprisesAux)
    updateFavoritesLocalStorage(favoriteEnterprisesAux)
  }

  const updateFavoritesLocalStorage = (favoriteEnterprisesAux: IFavoriteEnterpriseClaim[]) => {
    localStorage.setItem(USER_FAVORITES_ENTERPRISES, JSON.stringify(favoriteEnterprisesAux))
  }

  const isFavorite = () => {
    if (isFavoriteDefault == undefined) {
      let isFavoriteAux = false
      let favoritesAux: IFavoriteEnterpriseClaim[] =
        auth.loginUser[0] != null && auth.loginUser[0].User != null
          ? JSON.parse(localStorage.getItem(USER_FAVORITES_ENTERPRISES) ?? '[]')
          : []
      favoritesAux.forEach((element) => {
        if (element.EnterpriseId == enterpriseId) {
          isFavoriteAux = true
          return
        }
      })
      return isFavoriteAux
    } else {
      return isFavoriteDefault
    }
  }

  return (
    <>
      <button className="h-full w-full" aria-label='Favoritar Empreendimento'>
        <div
          className="border border-gray-200 content-center rounded-full w-[48px] h-[48px] text-center cursor-pointer"
          onClick={() => handlefavoriteEnterprise(isFavoriteEnterprise)}
        >
          <Suspense fallback={<SkeletonLoading />}>
            <>
              {isLoadingFavorite || isLoadingFavoriteDelete ? (
                <img
                  alt="icon-favorite"
                  width={15}
                  src={IconLoading}
                  className="inline w-[15px] h-[15px] pt-1"
                  style={{ verticalAlign: 'sub' }}
                />
              ) : (
                <svg
                  width="21"
                  height="19"
                  viewBox="0 0 21 19"
                  fill="none"
                  className='inline-block'
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.64799 3.21135C2.23013 3.62921 1.89865 4.12529 1.6725 4.67126C1.44635 5.21723 1.32996 5.8024 1.32996 6.39335C1.32996 6.9843 1.44635 7.56947 1.6725 8.11544C1.89865 8.66141 2.23013 9.15749 2.64799 9.57535L10.33 17.2573L18.012 9.57535C18.8559 8.73143 19.33 7.58683 19.33 6.39335C19.33 5.19987 18.8559 4.05527 18.012 3.21135C17.1681 2.36743 16.0235 1.89332 14.83 1.89332C13.6365 1.89332 12.4919 2.36743 11.648 3.21135L10.33 4.52935L9.012 3.21135C8.59413 2.79348 8.09805 2.46201 7.55208 2.23586C7.00611 2.00971 6.42095 1.89331 5.83 1.89331C5.23904 1.89331 4.65388 2.00971 4.10791 2.23586C3.56194 2.46201 3.06586 2.79348 2.64799 3.21135V3.21135Z"
                    stroke="#F15C00"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill={isFavoriteEnterprise ? '#F15C00' : ''}
                  />
                </svg>
              )}
            </>
          </Suspense>
        </div>
      </button>
      <ModalError
        showModal={showModalError}
        closeModal={handleCloseModal}
        title="Erro!"
        description="Houve um erro ao adicionar aos favoritos, tente logar novamente."
      />
    </>
  )
}
